import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import LoanPlans from "./loanPlans";
import LoanPlanDetail from "./loanPlanDetail";

export default function LoanPlansConfigPage() {
  const active = localStorage.getItem("setActivePage");
  return (
    <Switch>
      {<Redirect exact={true} from="/plans" to={`/plans/loanPlans`} />}

      <ContentRoute
        path="/plans/loanPlans"
        component={LoanPlans}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/plans/loanPlanDetail"
        component={LoanPlanDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
